import { RootState } from '@/store/store'
import { EntryFieldValidationError } from './entries-edit.slice'

export const selectActiveEditValidationError = (state: RootState): EntryFieldValidationError | null => {
  return state.medSummaryEntryEditState.activeEdit?.validationError ?? null
}

export const selectActiveEditPendingValue = (state: RootState): string => {
  return state.medSummaryEntryEditState.activeEdit?.pendingValue ?? ''
}
